import { render } from "./new-instruction.vue?vue&type=template&id=7d8d0514&scoped=true"
import script from "./new-instruction.vue?vue&type=script&lang=js"
export * from "./new-instruction.vue?vue&type=script&lang=js"

import "./new-instruction.vue?vue&type=style&index=0&id=7d8d0514&lang=scss&scoped=true"

import exportComponent from "/Users/mac/richlesse/41devs/teamsecu/teamsecu-dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d8d0514"]])

export default __exports__